import { render, staticRenderFns } from "./MerchantControlBar.vue?vue&type=template&id=5e31f312&scoped=true&"
import script from "./MerchantControlBar.vue?vue&type=script&lang=js&"
export * from "./MerchantControlBar.vue?vue&type=script&lang=js&"
import style0 from "./MerchantControlBar.vue?vue&type=style&index=0&id=5e31f312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e31f312",
  null
  
)

export default component.exports